import React, { useCallback, useEffect, useState } from 'react';
import { View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { toast } from './toast-api';
import { dismissToast, getSnapshot, subscribe } from './toast-store';
import { Toast } from './toast';
import type { ToastData } from './types';

const MAX_VISIBLE = 3;

export function Toaster() {
  const [toasts, setToasts] = useState<readonly ToastData[]>(getSnapshot);

  useEffect(() => {
    return subscribe(setToasts);
  }, []);

  const handleDismiss = useCallback((id: string) => {
    const toastData = getSnapshot().find((t) => t.id === id);
    toastData?.onDismiss?.();
    dismissToast(id);
  }, []);

  // Only show the most recent MAX_VISIBLE toasts
  const visibleToasts = toasts.slice(-MAX_VISIBLE);

  if (visibleToasts.length === 0) return null;

  return (
    <SafeAreaView
      style={{ position: 'absolute', top: 0, left: 0, right: 0, pointerEvents: 'box-none' }}
      edges={['top']}
    >
      <View style={{ flexDirection: 'column', alignItems: 'center', paddingTop: 8, pointerEvents: 'box-none' }}>
        {visibleToasts.map((t) => (
          <Toast key={t.id} toast={t} onDismiss={handleDismiss} />
        ))}
      </View>
    </SafeAreaView>
  );
}

// Keep ToastProvider as a wrapper for backward compat with _layout.tsx
export function ToastProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      {children}
      <Toaster />
    </>
  );
}

export function useToast() {
  return { toast };
}
